import {
  REFERRALS,
  MEMBERS,
  BULK_DELETE,
  REFERRALS_URL,
} from "constants/endpoints";
import { deleteApi, get, post, put, patch } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";

export const getReferrals = async (obj) => {
  const params = {
    page: obj?.page || 1,
    perPage: obj?.perPage || 10,
    search: obj?.search || "",
    active: obj?.active || false,
    county: Array.isArray(obj?.county)
      ? obj.county.map((item) => item.value).join(",")
      : obj?.county || "",
    referral_programe: Array.isArray(obj?.referral_programe)
      ? obj.referral_programe.map((item) => item.value).join(",")
      : obj?.referral_programe || "",
    health_plan_id: Array.isArray(obj?.health_plan_id)
      ? obj.health_plan_id.map((item) => item.value).join(",")
      : obj?.health_plan_id || "",
    referral_status: obj.referral_status || "",
    key: obj?.key ? obj.key : "",
    order: obj?.order ? obj.order : "",
  };

  try {
    const queryString =
      `${REFERRALS}?page=${params.page}&sort=${params.key}&order=${
        params.order
      }&per=${params.perPage}&query=${encodeURIComponent(
        params.search
      )}&filter[referral_status]=${params.referral_status}` +
      `${params.active ? "&filter[status]=active" : ""}` +
      `${
        params.county
          ? `&filter[county]=${encodeURIComponent(params.county)}`
          : ""
      }` +
      `${
        params.referral_programe
          ? `&filter[referral_programe]=${encodeURIComponent(
              params.referral_programe
            )}`
          : ""
      }` +
      `${
        params.health_plan_id
          ? `&filter[health_plan_id]=${encodeURIComponent(
              params.health_plan_id
            )}`
          : ""
      }`;

    const result = await get(queryString, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getReferral = async (id) => {
  try {
    const result = await get(`api/v1/referrals/${id}`, true);
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const deleteBulkReferral = async (data) => {
  try {
    const result = await put(`${REFERRALS_URL}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral deleted successfully"
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
  }
};

export const createReferral = async (data, setErrors = () => {}) => {
  try {
    const result = await post(`api/v1/referrals`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral created successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={
          error?.response?.data?.errors?.base || error?.response?.statusText
        }
      />
    );
    console.log(error);
  }
};
export const updateReferral = async (data, id, setErrors = () => {}) => {
  try {
    const result = await put(`api/v1/referrals/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Referral updated successfully"
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.data?.errors?.base || error?.response?.statusText}
      />
    );
    console.log(error);
  }
};
